import React, { useEffect, useRef, useState } from "react";
import {
    Col,
    Container,
    Form,
    Nav,
    Overlay,
    Row,
    Tab,
    Tabs,
    Table,
    Button,
    Tooltip,
    InputGroup,
    Accordion,
} from "react-bootstrap";
import BreadcrumbsNavManagement from "./common-component/BreadcrumbsNavManagement";
import profileicon from "../assets/images/profileicon.svg";
import accountprofile from "../assets/images/accountprofile.svg";
import hideeye from "../assets/images/hideeye.svg";
import authentication from "../assets/images/authentication.svg";
import contacts from "../assets/images/contacts.svg";
import purchases from "../assets/images/purchases.svg";
import billingsplans from "../assets/images/billingsplans.svg";
import automation from "../assets/images/automation.svg";
import notificationprofile from "../assets/images/notificationprofile.svg";
import policyprofile from "../assets/images/policyprofile.svg";
import privacypolicy from "../assets/images/privacypolicy.svg";
import deleteprofile from "../assets/images/deleteaccountprofile.svg";
import RightArrow from "../assets/images/dropdownafter.svg";
import WalletSVG from "../assets/images/WalletSVG.svg";
import Support from "../assets/images/Support.svg";
import legal from "../assets/images/legal.svg";
import BillingManagementModel from "../Modals/ManagementModels/BillingManagementModel";
import PaymentMethodManagementModel from "../Modals/ManagementModels/PaymentMethodManagementModel";
import LegalManagementModel from "../Modals/ManagementModels/LegalManagementModel";
import ProfileManagementModel from "../Modals/ManagementModels/ProfileManagementModel";
import AccountManagementModel from "../Modals/ManagementModels/AccountManagementModel";
import AuthenticationManagementModel from "../Modals/ManagementModels/AuthenticationManagementModel";
import ContactManagemntModel from "../Modals/ManagementModels/ContactManagemntModel";
import PurchaseManagementModel from "../Modals/ManagementModels/PurchaseManagementModel";
import CasesManagementModel from "../Modals/ManagementModels/CasesManagementModel";
import CaseHistoryManagementModel from "../Modals/ManagementModels/CaseHistoryManagementModel";
import WorkflowManagementModel from "../Modals/ManagementModels/WorkflowManagementModel";
import MachinesManagementModel from "../Modals/ManagementModels/MachinesManagementModel";
import NotificationsManagementModel from "../Modals/ManagementModels/NotificationsManagementModel";
import LoginLogManagementModel from "../Modals/ManagementModels/LoginLogManagementModel";
import PolicyManagementModel from "../Modals/ManagementModels/PolicyManagementModel";
import DeleteAccountManagementModel from "../Modals/ManagementModels/DeleteAccountManagementModel";
import actionLog from "../assets/images/actionLog.svg";
import { useLocation, useNavigate } from "react-router-dom";
import MemberShipSubscription from "../Modals/ManagementModels/MemberShipSubscription";
import { useSelector } from "react-redux";
import Contact from "./common-component/Contact";
import OrderManagementModal from "../Modals/ManagementModels/OrderManagementModal";
import TermsAndConditionModal from "../Modals/ManagementModels/TermsAndConditionModal";
import PasswordVault from "./common-component/PasswordVault";
import {
    PaymentStatusCheck,
    PaymentMethod_PaymentStatusCheck,
} from "../services/ReduxTookit/Slice/InvoiceRedux";
import { SubscriptionGetList } from "../services/ReduxTookit/Slice/SubscriptionsRedux";
import { GetByPrimarykey } from "../services/ReduxTookit/Slice/UserRedux";
import { useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";

import payment_cancel from "../assets/images/payment_cancel.svg";
import payment_inprocess from "../assets/images/payment_inprocess.svg";
import payment_success from "../assets/images/payment_success.svg";
import payment_wait from "../assets/images/payment_wait.svg";
import { GoogleToken } from "../services/ReduxTookit/Slice/GoogleRedux";
import { OAuthVaultExchangeToken } from "../services/ReduxTookit/Slice/OAuthVaultRedux";
import { resolveOAuthProvider } from "../Modals/OAuthProviderConfig";
import { googleString } from "../services/ReduxTookit/UserInfoSlice";
import InvoicesManagementModel from "../Modals/ManagementModels/InvoicesManagementModel";
import WalletManagement from "../Modals/ManagementModels/Payments/WalletManagement";
import Nodata from "./common-component/Nodata";
import { toast } from "react-toastify";

import aws from "../assets/images/aws.svg";
import InfrastructureAutomation from "../Modals/ManagementModels/InfrastructureAutomation";


function BillingAndCostManagementListing() {
    const dispatch = useDispatch();
    let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
    const [dataId, setDataId] = useState(null);
    const [passwordWalletState, setPasswordWalletState] = useState(null);

    const [dataHistoryId, setDataHistoryId] = useState(null);
    const [passwordPass, setPasswordPass] = useState(false);

    const location = useLocation();

    let IsWorkflowUser = window?.location?.href?.includes(
        `${process.env.REACT_APP_WORKFLOW}`
    );
    let Userdata = useSelector((state) => state?.userinfo?.UserInfo);

    const checkUserIsReviewer = () => {
        let isReviewer = false;
        if (Userdata?.associationtype === "Reviewers") {
            isReviewer = true;
        }
        return isReviewer;
    };
    const checkUserIsContact = () => {
        let isContact = false;
        if (Userdata?.associationtype === "Contacts") {
            isContact = true;
        }
        return isContact;
    };

    const checkUserIsDeveloper = () => {
        let DevRoute = window.location.href.includes(
            `${process.env.REACT_APP_DEV}`
        );
        let isDeveloper = false;
        if (DevRoute) {
            isDeveloper = true;
        }
        return isDeveloper;
    };

    const checkUserIsWorkflow = () => {
        let WorkflowRoute = window.location.href.includes(
            `${process.env.REACT_APP_WORKFLOW}`
        );
        let isWorkflow = false;
        if (WorkflowRoute) {
            isWorkflow = true;
        }
        return isWorkflow;
    };

    const BreadcrumbSingle = [
        {
            name: "profile",
            tagName: "Profile",
        },
        {
            name: "account",
            tagName: "Account",
        },
        {
            name: "authentication",
            tagName: "Password & Authentication",
        },
        {
            name: "contacts",
            tagName: "Contacts",
        },
        {
            name: "passwordvault",
            tagName: "Password Vault",
        },
        {
            name: "purchases",
            tagName: "Purchases",
            supportTag: "Billings & Plans",
        },
        {
            name: "wallet",
            tagName: "Wallet",
            supportTag: "Payment Management",
        },
        // {
        //     name: "balance",
        //     tagName: "Balance",
        //     supportTag: "Payment Management",
        // },
        {
            tagName: "Payment Method",
            name: "paymentmethod",
            supportTag: "Payment Management",
        },
        {
            name: "cases",
            tagName: "Cases",
            supportTag: "Support",
        },
        {
            name: "case-history",
            tagName: "Case History",
            supportTag: "Support",
        },
        {
            name: "membership",
            tagName: "Membership & Subscriptions",
            supportTag: "Billings & Plans",
        },
        {
            name: "spending",
            tagName: "Spending Limit",
            supportTag: "Billings & Plans",
        },
        {
            name: "ordermanagement",
            tagName: "Order Management",
            supportTag: "Billings & Plans",
        },
        // {
        //     tagName: "Payment Method",
        //     name: "paymentmethod",
        //     supportTag: "Billings & Plans",
        // },
        {
            tagName: "Billing & Cost Management",
            name: "billing",
            supportTag: "Billings & Plans",
        },
        {
            tagName: "Invoices",
            name: "invoices",
            supportTag: "Billings & Plans",
        },
        {
            name: "Legal",
            tagName: "Legal",
        },
        {
            name: "workflow",
            tagName: "Workflows",
            supportTag: "Code, Engineering & Automation",
        },
        {
            name: "machines",
            tagName: "Machines",
            supportTag: "Code, Engineering & Automation",
        },
        {
            name: "support",
            supportTag: "Support",
        },
        {
            name: "billingsplans",
            supportTag: "Billings & Plans",
        },
        {
            name: "automation",
            supportTag: "Code, Engineering & Automation",
        },
        {
            name: "infrastructureautomation",
            tagName: "Infrastructure Automation",
        },
        {
            name: "policy",
            tagName: "Privacy & Policy",
        },
        {
            name: "notification",
            tagName: "Notifications",
        },
        {
            name: "loginlog",
            tagName: "Login Log",
        },
        {
            name: "conditions",
            tagName: "Terms & Conditions",
        },
        {
            name: "deleteaccount",
            tagName: "Delete Account",
        },
    ];

    const [showRightPanel, setShowRightPanel] = useState("");
    const navigate = useNavigate();
    const [titleData, setTitleData] = useState("");
    const [OnlinePaymentDetails, setOnlinePaymentDetails] = useState({
        message: "",
        paymentsessionid: "",
        paymenttransactionid: "",
        from: "",
        isshow: false,
    });
    const getMainTitle = (name) => {
        setTitleData(BreadcrumbSingle?.find((item) => item?.name === name));
    };

    useEffect(() => {
        getMainTitle(showRightPanel);
    }, [showRightPanel]);

    const activePasswordVaultModule = (encryptedValue) => { };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const from = queryParams.get("from");
        const sessionId = queryParams.get("session_id");
        const paymentmethod = queryParams.get("pm");
        location?.search?.replaceAll("?", "");
        const encryptedValue = queryParams.get("code");

        if (from && sessionId) {
            if (from.toLowerCase() === "wallet") {
                setOnlinePaymentDetails({
                    message: "APICALLING",
                    paymentsessionid: "",
                    paymenttransactionid: "",
                    from: from,
                    isshow: true,
                });
                const holdForAPIResponce = async () => {
                    await fnPaymentStatusCheck(from, sessionId);
                    queryParams.delete("session_id");
                    navigate(`${location.pathname}?${queryParams.toString()}`, { state: "wallet" });
                    setShowRightPanel("wallet");
                }
                holdForAPIResponce()
            } else if (from.toLowerCase() === "bill") {
                setOnlinePaymentDetails({
                    message: "APICALLING",
                    paymentsessionid: "",
                    paymenttransactionid: "",
                    from: from,
                    isshow: true,
                });
                fnPaymentStatusCheck(from, sessionId);
                setShowRightPanel("billing");
            }
            else if (from.toLowerCase() === "bill_add_card") {
                setOnlinePaymentDetails({
                    message: "APICALLING",
                    paymentsessionid: "",
                    paymenttransactionid: "",
                    from: from,
                    isshow: true,
                });
                fnPaymentMethodPaymentStatusCheck(from, sessionId);
                setShowRightPanel("billing");
            }
            else if (from.toLowerCase() === "paymentmethod") {
                setOnlinePaymentDetails({
                    message: "APICALLING",
                    paymentsessionid: "",
                    paymenttransactionid: "",
                    from: from,
                    isshow: true,
                });
                fnPaymentMethodPaymentStatusCheck(from, sessionId);
                setShowRightPanel("paymentmethod");
            }
            else if (from.toLowerCase() === "subscription") {
                setOnlinePaymentDetails({
                    message: "APICALLING",
                    paymentsessionid: "",
                    paymenttransactionid: "",
                    from: from,
                    isshow: true,
                });
                fnPaymentStatusCheck(from, sessionId);
                setShowRightPanel("membership");
            }
        } else if (paymentmethod) {
            setShowRightPanel("paymentmethod");
        } else if (encryptedValue) {
            if (localStorage.getItem("inputValue")) {
                let InputValueData = JSON.parse(localStorage.getItem("inputValue"));
                let type = InputValueData?.type ? InputValueData?.type : "Google Authenticator";
                let displayname = InputValueData?.displayname ? InputValueData?.displayname : type;
                let selectedScopes = InputValueData?.selectedScopes || [];
                let passwordvaultid = InputValueData?.passwordvaultid || 0;
                const matchedConfig = resolveOAuthProvider(InputValueData?.auth_provider || type);
                let authProvider = InputValueData?.auth_provider || matchedConfig?.id ||
                    (type.toLowerCase().includes("microsoft") ? "microsoft" :
                        type.toLowerCase().includes("dropbox") ? "dropbox" :
                        type.toLowerCase().includes("yahoo") ? "yahoo" : "google");

                if (authProvider !== "google") {
                    let redirectUri = window.location.origin + "/management-listing";
                    let shop = InputValueData?.shop || InputValueData?.shopDomain || "";
                    dispatch(OAuthVaultExchangeToken({
                        provider: authProvider,
                        encryptedValue,
                        type,
                        displayname,
                        selectedScopes,
                        redirectUri,
                        shop,
                        passwordvaultid
                    }))?.then((res) => {
                        localStorage.removeItem("inputValue");
                        if (res?.payload?.data?.message) {
                            if (res?.payload?.data?.status_code === 1) {
                                toast.success(res.payload.data.message);
                            } else {
                                toast.error(res.payload.data.message);
                            }
                        }
                        navigate("/management-listing", {
                            state: "passwordvault",
                        });
                    });
                } else {
                    dispatch(GoogleToken({ encryptedValue, type, displayname, selectedScopes, passwordvaultid }))?.then((res) => {
                        localStorage.removeItem("inputValue");
                        if (res?.payload?.data?.message) {
                            if (res?.payload?.data?.status_code === 1) {
                                toast.success(res.payload.data.message);
                            } else {
                                toast.error(res.payload.data.message);
                            }
                        }
                        navigate("/management-listing", {
                            state: "passwordvault",
                        });
                    });
                }
            }
        } else {
            if (location?.state) {
                setShowRightPanel(location?.state);
            } else {
                setShowRightPanel("profile");
            }
        }
    }, [location]);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const sidebarRef = useRef(null);

    // Function to handle clicks outside the sidebar
    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsCollapsed(false);
            }
        }

        // Add event listener when sidebar is open
        if (isCollapsed) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isCollapsed]);

    const fnPaymentStatusCheck = async (from, sessionId) => {
        let message = "";
        let paymentsessionid = "";
        let paymenttransactionid = "";

        try {
            const rest = await dispatch(PaymentStatusCheck(sessionId));
            if (
                rest &&
                rest.payload &&
                rest.payload.isValidate &&
                rest.payload.data
            ) {
                message = rest.payload.data.message;
                paymentsessionid = rest.payload.data.data.paymentsessionid;
                paymenttransactionid = rest.payload.data.data.paymenttransactionid;
                if (from.toLowerCase() === "subscription" && message === "SUCCEEDED") {
                    dispatch(SubscriptionGetList());
                    dispatch(GetByPrimarykey({}));
                }
            }
        } catch (error) { }

        setOnlinePaymentDetails({
            message: message,
            paymentsessionid: paymentsessionid,
            paymenttransactionid: paymenttransactionid,
            from: from,
            isshow: true,
        });
    };

    const fnPaymentMethodPaymentStatusCheck = async (from, sessionId) => {
        let message = "";
        let paymentsessionid = "";
        let paymenttransactionid = "";

        try {
            const rest = await dispatch(PaymentMethod_PaymentStatusCheck(sessionId));
            if (
                rest &&
                rest.payload &&
                rest.payload.isValidate &&
                rest.payload.data
            ) {
                message = rest.payload.data.message;
                paymentsessionid = rest.payload.data.data.paymentsessionid;
                paymenttransactionid = rest.payload.data.data.paymenttransactionid;
            }
        } catch (error) { }

        setOnlinePaymentDetails({
            message: message,
            paymentsessionid: paymentsessionid,
            paymenttransactionid: paymenttransactionid,
            from: from,
            isshow: true,
        });
    };

    function refreshpagedata(from) {
        if (from.toLowerCase() === "bill" || from.toLowerCase() === "bill_add_card") {
            navigate("/management-listing", {
                state: "billing",
            });
        }
        else if (from.toLowerCase() === "subscription") {
            dispatch(SubscriptionGetList());
            dispatch(GetByPrimarykey({}));
            navigate("/management-listing", {
                state: "membership",
            });
        }
        else if (from.toLowerCase() === "paymentmethod") {
            navigate("/management-listing", {
                state: "paymentmethod",
            });
        }
    }

    return (
        <div className="BillingAndCostManagement-page-main having-small-blue-bg  all-page-top management-listing-main">
            <Container className="container-1520">
                <div className="top-bot-section justify-content-between align-items-start gap-3">
                    <div className="position-relative z-2">
                        <BreadcrumbsNavManagement pageNav={titleData} />
                    </div>
                </div>
            </Container>
            <div className="main-page-content">
                <Container className="container-1520">
                    <Row>
                        <Col xl={3}>
                            <div
                                className={`profile-main-sidebar ${isCollapsed ? "collapsed" : ""
                                    }`}
                                ref={sidebarRef}
                            >
                                <div className="all-categories-of-market-place">
                                    <button
                                        className="btn p-0 mb-3 profile-collapse"
                                        onClick={() => setIsCollapsed(!isCollapsed)}
                                    >
                                        <img src={RightArrow} alt="imageright" />
                                    </button>
                                    <Accordion
                                        className="firstdatafetch"
                                        defaultActiveKey="0"
                                        alwaysOpen
                                    >
                                        <Accordion.Item
                                            eventKey="0"
                                            onClick={() =>
                                                navigate("/management-listing", { state: "profile" })
                                            }
                                        >
                                            <Accordion.Header className="profiletop-space">
                                                <div
                                                    className={
                                                        showRightPanel === "profile"
                                                            ? "active icon-sidebar"
                                                            : "icon-sidebar  "
                                                    }
                                                >
                                                    <img src={profileicon} alt="profileicon" />
                                                    <span>Profile</span>
                                                </div>
                                            </Accordion.Header>
                                        </Accordion.Item>
                                        {!checkUserIsReviewer() && !checkUserIsContact() && (
                                            <Accordion.Item
                                                eventKey="1"
                                                onClick={() =>
                                                    navigate("/management-listing", { state: "account" })
                                                }
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "account"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={accountprofile} alt="accountprofile" />
                                                        <span>Account</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}

                                        <Accordion.Item
                                            eventKey="2"
                                            onClick={() => {
                                                navigate("/management-listing", {
                                                    state: "authentication",
                                                });
                                                setPasswordPass(false);
                                            }}
                                        >
                                            <Accordion.Header>
                                                <div
                                                    className={
                                                        showRightPanel === "authentication"
                                                            ? "active icon-sidebar"
                                                            : "icon-sidebar"
                                                    }
                                                >
                                                    <img src={authentication} alt="authentication" />
                                                    <span>Password & Authentication</span>
                                                </div>
                                            </Accordion.Header>
                                        </Accordion.Item>
                                        {!checkUserIsReviewer() &&
                                            (!checkUserIsContact() || Userdata?.workflowroleid === 4) &&
                                            Userdata?.isorganization && (
                                                <Accordion.Item
                                                    eventKey="3"
                                                    onClick={() =>
                                                        navigate("/management-listing", {
                                                            state: "contacts",
                                                        })
                                                    }
                                                >
                                                    <Accordion.Header>
                                                        <div
                                                            className={
                                                                showRightPanel === "contacts"
                                                                    ? "active icon-sidebar"
                                                                    : "icon-sidebar"
                                                            }
                                                        >
                                                            <img src={contacts} alt="contacts" />
                                                            <span>Contacts</span>
                                                        </div>
                                                    </Accordion.Header>
                                                </Accordion.Item>
                                            )}
                                        <Accordion.Item
                                            eventKey="5"
                                            onClick={() => {
                                                navigate("/management-listing", {
                                                    state: "wallet",
                                                });
                                            }}
                                        >
                                            <Accordion.Header>
                                                <div
                                                    className={
                                                        showRightPanel === "wallet" ||
                                                            showRightPanel === "paymentmethod"
                                                            ? "active icon-sidebar"
                                                            : "icon-sidebar"
                                                    }
                                                >
                                                    <img src={WalletSVG} alt="wallet" />
                                                    <span>Payment Management</span>
                                                </div>
                                            </Accordion.Header>
                                            <ul className="ps-4">
                                                <li
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate("/management-listing", {
                                                            state: "wallet",
                                                        });
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        showRightPanel === "wallet" && "caseshigh-data"
                                                    }
                                                >
                                                    Wallet
                                                </li>
                                                <li
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate("/management-listing", {
                                                            state: "paymentmethod",
                                                        });
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className={
                                                        showRightPanel === "paymentmethod" &&
                                                        "caseshigh-data"
                                                    }
                                                >
                                                    Payment Method
                                                </li>
                                            </ul>
                                        </Accordion.Item>
                                        {IsWorkflowUser && (
                                            <Accordion.Item
                                                eventKey="3"
                                                onClick={() => {
                                                    navigate("/management-listing", {
                                                        state: "passwordvault",
                                                    });
                                                    setPasswordWalletState(false);
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "passwordvault"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={hideeye} alt="passwordvault" />
                                                        <span>Password Vault</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}
                                        {!checkUserIsReviewer() && (
                                            <Accordion.Item
                                                eventKey="5"
                                                onClick={() => {
                                                    if (showRightPanel !== "cases") {
                                                        setDataId(null);
                                                        navigate("/management-listing", {
                                                            state: "cases",
                                                        });
                                                    }
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "cases" ||
                                                                showRightPanel === "support" ||
                                                                showRightPanel === "case-history"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={Support} alt="support" />
                                                        <span>Support</span>
                                                    </div>
                                                </Accordion.Header>
                                                <ul className="ps-4">
                                                    <li
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setDataId(null);
                                                            navigate("/management-listing", {
                                                                state: "cases",
                                                            });
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        className={
                                                            showRightPanel === "cases" && "caseshigh-data"
                                                        }
                                                    >
                                                        Cases
                                                    </li>
                                                    <li
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setDataHistoryId(null);
                                                            navigate("/management-listing", {
                                                                state: "case-history",
                                                            });
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        className={
                                                            showRightPanel === "case-history" &&
                                                            "caseshigh-data"
                                                        }
                                                    >
                                                        Case History
                                                    </li>
                                                </ul>
                                            </Accordion.Item>
                                        )}

                                        {!checkUserIsReviewer() && !checkUserIsContact() && (
                                            <Accordion.Item
                                                eventKey="6"
                                                onClick={() => {
                                                    if (showRightPanel !== "membership") {
                                                        navigate("/management-listing", {
                                                            state: "membership",
                                                        });
                                                    }
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "purchases" ||
                                                                showRightPanel === "billingsplans" ||
                                                                showRightPanel === "membership" ||
                                                                showRightPanel === "spending" ||
                                                                showRightPanel === "billing" ||
                                                                showRightPanel === "invoices" ||
                                                                showRightPanel === "ordermanagement"
                                                                // showRightPanel === "paymentmethod"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={billingsplans} alt="billingsplans" />
                                                        <span>Billings & Plans</span>
                                                    </div>
                                                </Accordion.Header>
                                                <ul className="ps-4">
                                                    <li
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate("/management-listing", {
                                                                state: "membership",
                                                            });
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        className={
                                                            showRightPanel === "membership" &&
                                                            "caseshigh-data"
                                                        }
                                                    >
                                                        Membership & Subscriptions
                                                    </li>
                                                    {/* <li
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate("/management-listing", {
                                                                state: "paymentmethod",
                                                            });
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        className={
                                                            showRightPanel === "paymentmethod" &&
                                                            "caseshigh-data"
                                                        }
                                                    >
                                                        Payment Method
                                                    </li> */}

                                                    {/* Confirmed from Satish/Ashish */}
                                                    {checkUserIsWorkflow() && (
                                                        <>
                                                            <li
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigate("/management-listing", {
                                                                        state: "ordermanagement",
                                                                    });
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                                className={
                                                                    showRightPanel === "ordermanagement" &&
                                                                    "caseshigh-data"
                                                                }
                                                            >
                                                                Orders
                                                            </li>
                                                            {!checkUserIsReviewer() &&
                                                                !checkUserIsContact() && (
                                                                    <li
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            navigate("/management-listing", {
                                                                                state: "purchases",
                                                                            });
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                        className={
                                                                            showRightPanel === "purchases" &&
                                                                            "caseshigh-data"
                                                                        }
                                                                    >
                                                                        Machine Purchases
                                                                    </li>
                                                                )}
                                                            <li
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigate("/management-listing", {
                                                                        state: "billing",
                                                                    });
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                                className={
                                                                    showRightPanel === "billing" &&
                                                                    "caseshigh-data"
                                                                }
                                                            >
                                                                Bills
                                                            </li>
                                                        </>
                                                    )}

                                                    {/* Confirmed from Satish/Ashish */}
                                                    {checkUserIsDeveloper() && (
                                                        <li
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate("/management-listing", {
                                                                    state: "invoices",
                                                                });
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                            className={
                                                                showRightPanel === "invoices" &&
                                                                "caseshigh-data"
                                                            }
                                                        >
                                                            Invoices
                                                        </li>
                                                    )}
                                                </ul>
                                            </Accordion.Item>
                                        )}
                                        {!checkUserIsReviewer() && !checkUserIsContact() && (
                                            <Accordion.Item
                                                eventKey="7"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate("/management-listing", {
                                                        state: "Legal",
                                                    });
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "Legal"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={legal} alt="legal" />
                                                        <span>Legal</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}
                                        {!checkUserIsReviewer() && (
                                            <Accordion.Item
                                                eventKey="8"
                                                onClick={() => {
                                                    navigate("/management-listing", {
                                                        state: DevRoute ? "machines" : "workflow",
                                                    });
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "automation" ||
                                                                showRightPanel === "machines" ||
                                                                showRightPanel === "workflow"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={automation} alt="automation" />
                                                        <span>Code, Engineering & Automation</span>
                                                    </div>
                                                </Accordion.Header>
                                                <ul className="ps-4">
                                                    {!DevRoute ? (
                                                        <li
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate("/management-listing", {
                                                                    state: "workflow",
                                                                });
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                            className={
                                                                showRightPanel === "workflow" &&
                                                                "caseshigh-data"
                                                            }
                                                        >
                                                            Workflows
                                                        </li>
                                                    ) : (
                                                        <li
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate("/management-listing", {
                                                                    state: "machines",
                                                                });
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                            className={
                                                                showRightPanel === "machines" &&
                                                                "caseshigh-data"
                                                            }
                                                        >
                                                            Machines
                                                        </li>
                                                    )}
                                                </ul>
                                            </Accordion.Item>
                                        )}


                                        {IsWorkflowUser && (
                                            <Accordion.Item
                                                eventKey="3"
                                                onClick={() => {
                                                    navigate("/management-listing", {
                                                        state: "infrastructureautomation",
                                                    });
                                                }}
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "infrastructureautomation"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={aws} alt="Infrastructure Automation" />
                                                        <span>Infrastructure Automation</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}


                                        {!checkUserIsReviewer() && (
                                            <Accordion.Item
                                                eventKey="9"
                                                onClick={() =>
                                                    navigate("/management-listing", {
                                                        state: "notification",
                                                    })
                                                }
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "notification"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img
                                                            src={notificationprofile}
                                                            alt="notificationprofile"
                                                        />
                                                        <span>Notifications</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}
                                        {!checkUserIsReviewer() && (
                                            <Accordion.Item
                                                eventKey="9.5"
                                                onClick={() =>
                                                    navigate("/management-listing", {
                                                        state: "loginlog",
                                                    })
                                                }
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "loginlog"
                                                                ? "active icon-sidebar"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img
                                                            src={actionLog}
                                                            alt="loginlog"
                                                        />
                                                        <span>Login Log</span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}
                                        <Accordion.Item
                                            eventKey="10"
                                            onClick={() =>
                                                navigate("/management-listing", {
                                                    state: "policy",
                                                })
                                            }
                                        >
                                            <Accordion.Header>
                                                <div
                                                    className={
                                                        showRightPanel === "policy"
                                                            ? "active icon-sidebar"
                                                            : "icon-sidebar"
                                                    }
                                                >
                                                    <img src={privacypolicy} alt="privacypolicy" />
                                                    <span>Privacy & Policy</span>
                                                </div>
                                            </Accordion.Header>
                                        </Accordion.Item>
                                        <Accordion.Item
                                            eventKey="11"
                                            onClick={() =>
                                                navigate("/management-listing", {
                                                    state: "conditions",
                                                })
                                            }
                                        >
                                            <Accordion.Header>
                                                <div
                                                    className={
                                                        showRightPanel === "conditions"
                                                            ? "active icon-sidebar"
                                                            : "icon-sidebar"
                                                    }
                                                >
                                                    <img src={policyprofile} alt="policyprofile" />
                                                    <span>Terms & Conditions</span>
                                                </div>
                                            </Accordion.Header>
                                        </Accordion.Item>
                                        {!checkUserIsContact() && (
                                            <Accordion.Item
                                                eventKey="12"
                                                onClick={() =>
                                                    navigate("/management-listing", {
                                                        state: "deleteaccount",
                                                    })
                                                }
                                            >
                                                <Accordion.Header>
                                                    <div
                                                        className={
                                                            showRightPanel === "deleteaccount"
                                                                ? "active icon-sidebar deleteicon-red"
                                                                : "icon-sidebar"
                                                        }
                                                    >
                                                        <img src={deleteprofile} alt="deleteprofile" />
                                                        <span className="red-color-text">
                                                            Delete Account
                                                        </span>
                                                    </div>
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        )}
                                    </Accordion>
                                </div>
                            </div>
                        </Col>
                        <Col xl={9}>
                            {showRightPanel === "invoices" && <InvoicesManagementModel />}
                            {showRightPanel === "billing" && (<BillingManagementModel setShowRightPanel={setShowRightPanel} OnlinePaymentDetails={OnlinePaymentDetails} />)}
                            {showRightPanel === "wallet" && (<WalletManagement setShowRightPanel={setShowRightPanel} />)}
                            {showRightPanel === "paymentmethod" && (<PaymentMethodManagementModel OnlinePaymentDetails={OnlinePaymentDetails} />)}
                            {showRightPanel === "membership" && <MemberShipSubscription />}
                            {showRightPanel === "Legal" && <LegalManagementModel />}
                            {showRightPanel === "profile" && <ProfileManagementModel />}
                            {showRightPanel === "account" && <AccountManagementModel />}
                            {showRightPanel === "authentication" && (<AuthenticationManagementModel setPasswordPass={setPasswordPass} passwordPass={passwordPass} />)}
                            {showRightPanel === "contacts" && <Contact />}
                            {showRightPanel === "passwordvault" && (<PasswordVault setPasswordWalletState={setPasswordWalletState} passwordWalletState={passwordWalletState} />)}
                            {showRightPanel === "purchases" && <PurchaseManagementModel />}
                            {showRightPanel === "ordermanagement" && <OrderManagementModal />}
                            {showRightPanel === "cases" && (<CasesManagementModel dataId={dataId} setDataId={setDataId} />)}
                            {showRightPanel === "case-history" && (<CaseHistoryManagementModel dataHistoryId={dataHistoryId} setDataHistoryId={setDataHistoryId} />)}
                            {showRightPanel === "workflow" && <WorkflowManagementModel />}
                            {showRightPanel === "machines" && <MachinesManagementModel />}
                            {showRightPanel === "notification" && (<NotificationsManagementModel />)}
                            {showRightPanel === "loginlog" && <LoginLogManagementModel />}
                            {showRightPanel === "conditions" && <TermsAndConditionModal />}
                            {showRightPanel === "policy" && <PolicyManagementModel />}
                            {showRightPanel === "deleteaccount" && (<DeleteAccountManagementModel />)}
                            {showRightPanel === "infrastructureautomation" && (<InfrastructureAutomation />)}

                        </Col>
                    </Row>
                </Container>
            </div>
            {OnlinePaymentDetails && (
                <Modal
                    show={OnlinePaymentDetails.isshow}
                    onHide={(e) =>
                        setOnlinePaymentDetails({
                            ...OnlinePaymentDetails,
                            isshow: false,
                        })
                    }
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="delete-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="text-center">
                            {OnlinePaymentDetails.message === "SUCCEEDED" && (
                                <>
                                    <img src={payment_success} alt="SUCCEEDED" />
                                    <h4 className="text-success">
                                        {OnlinePaymentDetails.message}
                                    </h4>
                                    {OnlinePaymentDetails.from.toLowerCase() === "paymentmethod" || OnlinePaymentDetails.from.toLowerCase() === "bill_add_card" ? (
                                        <p className="text-success">
                                            Successfully added new method of payment.
                                        </p>
                                    ) : (
                                        <p className="text-success">
                                            Your payment was successful. Thank you!
                                        </p>
                                    )}
                                    <div className="d-flex align-items-center gap-2">
                                        <button
                                            className="btn btn-success"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOnlinePaymentDetails({
                                                    ...OnlinePaymentDetails,
                                                    isshow: false,
                                                });
                                                refreshpagedata(OnlinePaymentDetails.from);
                                            }}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </>
                            )}
                            {OnlinePaymentDetails.message === "CANCELED" && (
                                <>
                                    <img src={payment_cancel} alt="CANCELED" />
                                    <h4 className="text-danger">
                                        {OnlinePaymentDetails.message}
                                    </h4>
                                    <p className="text-danger">
                                        Your payment was canceled. No charges were made.
                                    </p>
                                    <div className="d-flex align-items-center gap-2">
                                        <button
                                            className="btn btn-danger"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOnlinePaymentDetails({
                                                    ...OnlinePaymentDetails,
                                                    isshow: false,
                                                });
                                                refreshpagedata(OnlinePaymentDetails.from);
                                            }}
                                        >
                                            Try Again
                                        </button>
                                    </div>
                                </>
                            )}
                            {(OnlinePaymentDetails.message === "PROCESSING" ||
                                OnlinePaymentDetails.message === "") && (
                                    <>
                                        <img src={payment_inprocess} alt="PROCESSING" />
                                        <h4 className="text-warning">
                                            {OnlinePaymentDetails.message}
                                        </h4>
                                        <p className="text-warning">
                                            Your payment is currently being processed.It may take up to
                                            48 hours for the payment to be cleared.{" "}
                                        </p>
                                        <div className="d-flex align-items-center gap-2">
                                            <button
                                                className="btn btn-warning"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setOnlinePaymentDetails({
                                                        ...OnlinePaymentDetails,
                                                        isshow: false,
                                                    });
                                                    refreshpagedata(OnlinePaymentDetails.from);
                                                }}
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </>
                                )}
                            {OnlinePaymentDetails.message === "APICALLING" && (
                                <>
                                    <img src={payment_wait} alt="WAIT" />
                                    <h4 className="">Wait for completion</h4>
                                    <p className="">
                                        Do not refresh your browser until you see the next message.
                                    </p>
                                </>
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
}

export default BillingAndCostManagementListing;
